import { func, oneOf, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import ButtonSmall from 'views/components/molecules/ButtonSmall'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import ButtonWithIconText from 'views/components/molecules/ButtonWithIconText'

const ModalShowButton = ({ modalId, component, onClick, ...rest }) => {
  const Component = component
  return (
    <Component
      {...rest}
      href={`#${modalId}`}
      data-a11y-dialog-show={modalId}
      onClick={event => {
        event.preventDefault()
        return onClick ? onClick(event) : undefined
      }}
      isReactControlled
    />
  )
}

ModalShowButton.propTypes = {
  ...Button.propTypes,
  // Button component uses onClick to check whether one of href,
  // onClick, type=submit or isClientsideControlled is set, but
  // ModalShowButton will always pass non–empty href.
  onClick: func,
  modalId: string.isRequired,
  component: oneOf([
    Button,
    ButtonAsLink,
    ButtonSmall,
    ButtonTransparent,
    ButtonWithIconText,
    IconCircleInfo,
  ]),
}

ModalShowButton.defaultProps = {
  ...Button.defaultProps,
  component: Button,
}

export default ModalShowButton
